import { createRouter, createWebHistory } from "@ionic/vue-router"
import type { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@/stores/auth"

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/dashboard" },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/Auth/Login.vue"),
    meta: { layout: "auth", public: true },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/pages/Auth/Register.vue"),
    meta: { layout: "auth", public: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/pages/Dashboard/Index.vue"),
  },
  {
    path: "/tasks",
    name: "tasks",
    component: () => import("@/pages/Tasks/Index.vue"),
  },
  {
    path: "/tasks/:id",
    redirect: (to) => ({ name: "task-edit", params: to.params }),
  },
  {
    path: "/tasks/new",
    name: "task-new",
    component: () => import("@/pages/Tasks/Form.vue"),
  },
  {
    path: "/tasks/:id/edit",
    name: "task-edit",
    component: () => import("@/pages/Tasks/Form.vue"),
  },
  {
    path: "/events",
    name: "events",
    component: () => import("@/pages/Events/Index.vue"),
  },
  {
    path: "/events/new",
    name: "event-new",
    component: () => import("@/pages/Events/Form.vue"),
  },
  {
    path: "/events/:id/edit",
    name: "event-edit",
    component: () => import("@/pages/Events/Form.vue"),
  },
  {
    path: "/projects",
    name: "projects",
    component: () => import("@/pages/Projects/Index.vue"),
  },
  {
    path: "/projects/:id",
    name: "project-show",
    component: () => import("@/pages/Projects/Show.vue"),
  },
  {
    path: "/projects/new",
    name: "project-new",
    component: () => import("@/pages/Projects/Form.vue"),
  },
  {
    path: "/projects/:id/edit",
    name: "project-edit",
    component: () => import("@/pages/Projects/Form.vue"),
  },
  {
    path: "/reminders",
    name: "reminders",
    component: () => import("@/pages/Reminders/Index.vue"),
  },
  {
    path: "/reminders/new",
    name: "reminder-new",
    component: () => import("@/pages/Reminders/Form.vue"),
  },
  {
    path: "/reminders/:id/edit",
    name: "reminder-edit",
    component: () => import("@/pages/Reminders/Form.vue"),
  },
  {
    path: "/habits/new",
    name: "habit-new",
    component: () => import("@/pages/Habits/Form.vue"),
  },
  {
    path: "/habits/:id/edit",
    name: "habit-edit",
    component: () => import("@/pages/Habits/Form.vue"),
  },
  {
    path: "/habits/:id",
    name: "habit-show",
    component: () => import("@/pages/Habits/Show.vue"),
  },
  {
    path: "/habits",
    name: "habits",
    component: () => import("@/pages/Habits/Index.vue"),
  },
  {
    path: "/alerts",
    name: "alerts",
    component: () => import("@/pages/Alerts/Index.vue"),
  },
  {
    path: "/ai",
    name: "ai",
    component: () => import("@/pages/Ai/Index.vue"),
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/pages/Reports/Index.vue"),
  },
  {
    path: "/guide",
    name: "guide",
    component: () => import("@/pages/Guide/Index.vue"),
  },
  {
    path: "/preferences",
    name: "preferences",
    component: () => import("@/pages/Preferences/Index.vue"),
  },
  {
    path: "/time-slots",
    name: "time-slots",
    component: () => import("@/pages/TimeSlots/Index.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/pages/Profile/Edit.vue"),
  },
  /*
   * Placeholder routes for the rest of the resources. Each will be replaced
   * by a real page component as the migration progresses (see
   * docs/architecture/frontend-migration.md Phase 2). Until then they 404
   * via the catch-all NotFound page.
   */
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/pages/NotFound.vue"),
  },
]

export const router = createRouter({
  history: createWebHistory("/app"),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.public) return true
  const auth = useAuthStore()
  if (!auth.isAuthenticated) {
    return { name: "login", query: { return_to: to.fullPath } }
  }
  return true
})
